import { useState, useEffect, useCallback } from "react";
import React from "react";
import SEO from "./SEO";

const translations = {
  tr: {
    // Görseldeki mesaja uyarlandı
    title: "BAŞARILI!",
    message: "Mesajınız başarıyla gönderildi. En kısa sürede size dönüş yapacağız.",
  },
  en: {
    title: "SUCCESS!",
    message: "Your message has been sent successfully! We will get back to you as soon as possible.",
  },
  fr: {
    title: "SUCCÈS!",
    message: "Votre message a été envoyé avec succès ! Nous vous recontacterons dans les plus brefs délais.",
  },
  ku: {
    title: "SERKEFTÎ!",
    message: "Peyama we bi serkeftî hate şandin! Em ê di demeke nêz de bi we re têkevin têkiliyê.",
  }
  // Eğer farklı dilleriniz varsa, onları da buraya ekleyebilirsiniz.
};

export const AppointmentSuccess = ({ lang = "tr", isDarkMode, onBack }) => {
  const t = translations[lang] || translations.tr;
  const [countdown, setCountdown] = useState(15); // Geri sayım için state eklendi

  // Modal'ı kapatma fonksiyonu oluşturuldu (useCallback performansı artırır)
  const handleClose = useCallback(() => {
    if (onBack) onBack();
  }, [onBack]);

  // Otomatik Kapanma (15 Saniye) ve Geri Sayım Mantığı
  useEffect(() => {
    // 1. Kapanma Zamanlayıcısı (15 saniye sonra kapat)
    const closeTimer = setTimeout(() => {
      handleClose();
    }, 15000);

    // 2. Geri Sayım Zamanlayıcısı (Her saniye countdown state'ini güncelle)
    const countdownTimer = setInterval(() => {
      setCountdown((prev) => (prev > 1 ? prev - 1 : 1));
    }, 1000);

    // Bileşen ayrıldığında her iki zamanlayıcıyı da temizle
    return () => {
      clearTimeout(closeTimer);
      clearInterval(countdownTimer);
    };
  }, [handleClose]);

  const seoContent = {
    tr: {
      title: "Randevu Başarılı",
      description: "Mesajınız başarıyla gönderildi. En kısa sürede size dönüş yapacağız.",
      keywords: "randevu başarılı, mesaj gönderildi, iletişim"
    },
    en: {
      title: "Appointment Success",
      description: "Your message has been sent successfully! We will get back to you as soon as possible.",
      keywords: "appointment success, message sent, contact"
    },
    fr: {
      title: "Rendez-vous Réussi",
      description: "Votre message a été envoyé avec succès ! Nous vous recontacterons dans les plus brefs délais.",
      keywords: "rendez-vous réussi, message envoyé, contact"
    },
    ku: {
      title: "Berfireh Serkeftî",
      description: "Peyama we bi serkeftî hate şandin! Em ê di demeke nêz de bi we re têkevin têkiliyê.",
      keywords: "berfireh serkeftî, peyam şand, têkilî"
    }
  };

  const seo = seoContent[lang] || seoContent.tr;

  return (
    <div style={{
      minHeight: "100vh",
      backgroundImage: "url('/img/law-photo1.png')",
      backgroundSize: "cover",
      backgroundPosition: "center",
      position: "relative",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    }}>
      <div style={{
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: isDarkMode ? "rgba(0,0,0,0.7)" : "rgba(0,0,0,0.4)"
      }}></div>

      <SEO
        title={seo.title}
        description={seo.description}
        keywords={seo.keywords}
        url="/appointment-success"
        lang={lang}
        image="img/law-photo1.png"
      />
      <div className="container" style={{ position: "relative", zIndex: 1 }}>
        <div className="row justify-content-center">
          <div className="col-md-6">
            <div style={{
              // Görseldeki koyu arkaplana daha uygun bir stil
              backgroundColor: "rgba(26,26,26,0.9)",
              borderRadius: "20px",
              padding: "50px",
              textAlign: "center",
              boxShadow: "0 20px 60px rgba(0,0,0,0.5)",
              position: "relative",
              color: "#fff" // Metin rengini beyaz yap
            }}>

              {/* Close Button (X) */}
              <button
                onClick={handleClose}
                style={{
                  position: "absolute",
                  top: "15px",
                  right: "15px",
                  width: "35px",
                  height: "35px",
                  borderRadius: "50%",
                  border: "none",
                  backgroundColor: "rgba(255,255,255,0.1)",
                  color: "#fff",
                  fontSize: "20px",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  transition: "all 0.3s"
                }}
                onMouseOver={(e) => {
                  e.target.style.backgroundColor = "rgba(255,255,255,0.2)";
                  e.target.style.transform = "rotate(90deg)";
                }}
                onMouseOut={(e) => {
                  e.target.style.backgroundColor = "rgba(255,255,255,0.1)";
                  e.target.style.transform = "rotate(0deg)";
                }}
              >
                ✕
              </button>

              {/* Başarı Mesajı (Görseldeki Gibi) */}
              <div style={{
                fontSize: "80px",
                marginBottom: "20px",
                color: "#4CAF50" // Tik işareti rengi
              }}>
                ✓
              </div>

              {/* Başlık */}
              <h2 style={{ color: "#fff", fontSize: "28px", marginBottom: "10px" }}>
                {t.title}
              </h2>

              {/* Mesaj */}
              <p style={{ color: "#bbb", fontSize: "16px", marginBottom: "25px" }}>
                {t.message}
              </p>

              {/* Kapanma Geri Sayımı (Görseldeki stile uyarlandı) */}
              <div style={{
                height: "5px",
                width: "100%",
                backgroundColor: "#333",
                borderRadius: "5px",
                overflow: "hidden",
                marginBottom: "20px"
              }}>
                <div style={{
                  height: "100%",
                  width: `${(countdown / 15) * 100}%`,
                  backgroundColor: "#4CAF50",
                  transition: 'width 1s linear' // Yumuşak geçiş
                }}></div>
              </div>

              {/* Geri Sayım Metni */}
              <p style={{ color: "#bbb", fontSize: "14px", marginBottom: "30px" }}>
                will close in {countdown} seconds...
              </p>

              {/* Kapat Butonu */}
              <button onClick={handleClose} style={{
                padding: "10px 20px",
                backgroundColor: "#4CAF50", // Yeşil Buton
                color: "#fff",
                border: "none",
                borderRadius: "5px",
                fontSize: "16px",
                fontWeight: "bold",
                cursor: "pointer",
              }}>
                Close
              </button>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
};